import { useState } from 'react';
import {
  TabContentProps,
  TabItem,
  TabProps,
  TabsProps,
} from '../interface/interface';

const Tab = ({ label, isActive, onClick, indicator }: TabProps) => {
  return (
    <div
      className={`tab mr-2 2xl:mr-4 pb-1 font-semibold cursor-pointer relative
        ${
          isActive
            ? 'active text-primary-blue-500 text-base md:text-xl 2xl:text-2xl border-b-4 border-solid border-secondary-pink-500'
            : 'text-lg 2xl:text-xl text-secondary-cornflowerblue-500'
        }`}
      onClick={onClick}
    >
      {label}{' '}
      {indicator && (
        <span className="absolute bg-primary-red-400 h-2.5 w-2.5 rounded-full top-0 -right-2"></span>
      )}
    </div>
  );
};

const TabContent = ({ children, isActive }: TabContentProps) => {
  return isActive ? <div className="tab-content">{children}</div> : null;
};

const Tabs = ({ tabs, activeTabLabel, isHome = false }: TabsProps) => {
  const initialActiveTab = activeTabLabel
    ? tabs.find((tb) => tb.label === activeTabLabel)?.id
    : tabs[0]?.id;

  const [activeTab, setActiveTab] = useState<TabItem['id']>(initialActiveTab!);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    if (isHome) {
      localStorage.setItem('homeTab', tabId);
    }
  };

  return (
    <div className="tabs-container relative pt-7">
      <div className="tab-list inline-flex mb-8 items-center">
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            label={tab.label}
            isActive={activeTab === tab.id}
            onClick={() => handleTabClick(tab.id)}
            indicator={tab?.indicator}
          />
        ))}
      </div>
      <div className="tab-contents">
        {tabs.map((tab) => (
          <TabContent key={tab.id} isActive={activeTab === tab.id}>
            {tab.component}
          </TabContent>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
